export function removeHtmlTag(html) {
	const regex = /(&nbsp;|<([^>]+)>)/gi;
	console.log('removehtml: ', html);
	return html === null ? '' : html.replace(regex, '');
}
